import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCustomersV2Route: InvariantJiraRoute = {
	name: 'servicedesk-customers-v2',
	path: '/jira/servicedesk/projects/:projectKey/customers',
	exact: true,
};
